<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} cuenta bancaria
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-3">
                  <label>Tipo de cuenta<span class="required"></span></label>
                  <select class="form-control" id="typeAccountSelected" formControlName="typeaccount_id" required>
                    <option *ngIf="!isEdit" value="null">Seleccione</option>
                    <option *ngFor="let item of typeaccounts" [value]="item.id">{{ item.description }}</option>
                  </select>
                </div>
                <div class="form-group col-lg-3">
                  <label>Banco<span class="required"></span>
                  </label>
                  <select class="form-control" id="bankSelected" formControlName="bank_id" required>
                    <option *ngIf="!isEdit" value="null">Seleccione</option>
                    <option *ngFor="let item of banks" [value]="item.id">{{ item.description }}</option>
                  </select>
                </div>
                <div class="form-group col-lg-3">
                  <label>Moneda<span class="required"></span></label>
                  <select class="form-control" id="currencySelected" formControlName="currency_id" required>
                    <option *ngFor="let item of currencies" [value]="item.id">{{ item.plural }} ({{item.symbol}})
                    </option>
                  </select>
                </div>
                <div class="form-group col-lg-3">
                  <label>Nombre cuenta (referencia)<span class="required"></span></label>
                  <input type="text" id="account_name" required formControlName="name" class="form-control">
                </div>
                <div class="form-group col-lg-6">
                  <label>N° de cuenta<span class="required"></span></label>
                  <input type="text" id="account_number_account" class="form-control" formControlName="number_account"
                    required>
                </div>
                <div class="form-group col-lg-6">
                  <label>N° CCI (Código interbancario)<span class="required"></span></label>
                  <input type="text" id="account_cci_account" class="form-control" formControlName="cci_account"
                    required>
                </div>
                <div class="form-group col-lg-6">
                  <label>Titular cuenta <span class="required"></span></label>
                  <input type="text" id="account_headline" class="form-control" formControlName="headline">
                </div>
                <div class="form-group col-lg-6">
                  <label>Descripción</label>
                  <textarea class="form-control no-resize" id="account_description" formControlName="description"
                    rows="2"></textarea>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    Guardar Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
